export const MALL_TRACKING_CHANNEL_PARAM = 'mall_tracking_channel'
export const MALL_TRACKING_CHANNEL_STORAGE_KEY = 'mall_tracking_channel'

const MAX_TRACKING_CHANNEL_LENGTH = 128

function getWindow() {
  return typeof window !== 'undefined' ? window : null
}

function normalizeTrackingChannel(value) {
  return String(value ?? '').trim().slice(0, MAX_TRACKING_CHANNEL_LENGTH)
}

function getUrlTrackingChannel(win) {
  if (!win?.location)
    return ''

  try {
    const hashQuery = String(win.location.hash || '').split('?')[1] || ''
    const fullQuery = `${win.location.search || ''}&${hashQuery}`.replace(/^&/, '')
    return normalizeTrackingChannel(
      new URLSearchParams(fullQuery).get(MALL_TRACKING_CHANNEL_PARAM),
    )
  }
  catch {
    return ''
  }
}

export function captureMallTrackingChannel(win = getWindow()) {
  if (!win)
    return ''

  const urlChannel = getUrlTrackingChannel(win)
  if (urlChannel) {
    try {
      win.localStorage?.setItem(MALL_TRACKING_CHANNEL_STORAGE_KEY, urlChannel)
    }
    catch {
      // Storage may be unavailable in privacy mode; the current URL value still applies.
    }
    return urlChannel
  }

  try {
    return normalizeTrackingChannel(
      win.localStorage?.getItem(MALL_TRACKING_CHANNEL_STORAGE_KEY),
    )
  }
  catch {
    return ''
  }
}

export function getMallTrackingChannel(win = getWindow()) {
  return captureMallTrackingChannel(win)
}
